import BillingAccountCard from './BillingAccountCard';

export default BillingAccountCard;
